import { useContext, createContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { usePassportRequests } from '../services/passports';

const PassportContext = createContext(null);

export const PassportContextProvider = ({ children }) => {
  const { email } = useParams();
  const { data, isLoading, hasNextPage, fetchNextPage, refetch } = usePassportRequests(email);

  useEffect(() => {
    refetch();

    // eslint-disable-next-line
  }, [email]);

  return (
    <PassportContext.Provider
      value={{
        passportRequests:
          data?.pages?.map(({ passportRequests }) => passportRequests)?.flat() || [],
        isPassportRequestsLoading: isLoading,
        hasNextPage,
        fetchNextPage
      }}
    >
      {children}
    </PassportContext.Provider>
  );
};

export function usePassport() {
  const context = useContext(PassportContext);

  if (!context) {
    throw new Error('usePassport must be used within a PassportContextProvider');
  }

  return context;
}
